import React from 'react';
import labeledItemStyle from 'acscp/components/common/labeledItem.module.scss';
import styles from './additionalItem.module.scss';

export const AdditionalItem: React.SFC<{ label: React.ReactNode, icon: any }>
    = ({ label, icon, children }) => {
        return children ? (
            <div className={styles.AdditionalItem}>
                <img className={styles.Icon} src={icon} alt={'Icon'}/>
                <div className={labeledItemStyle.Label}>
                    {label}
                </div>
                <div>{children}</div>
            </div>
        ) : null;
    };
